// extracted by mini-css-extract-plugin
module.exports = {"btnContainer":"styles_btnContainer_3R6KrqebSOY6MtvZJc70Cr","savebtn":"styles_savebtn_S_jssy4YQOx0hC_nUg_Go","plusIcon":"styles_plusIcon_D64W5RNqh_f6a6NqwBB_M"};